module.exports = {"appUrl":"https://account.grand-shooting.com","stripe_key":"pk_live_H2H4bgZL3cmEgpwvm1XFEeSU"}


//////////////////
// WEBPACK FOOTER
// ./src/actions/config.json
// module id = 21
// module chunks = 0